// `?url` imports only the files' URLs; wheelText.ts downloads the files of one language.

import csFull from 'src/assets/wheel-text/cs-full.svg?url';
import csPreview from 'src/assets/wheel-text/cs-preview.svg?url';
import csWizard from 'src/assets/wheel-text/cs-wizard.svg?url';

import deFull from 'src/assets/wheel-text/de-full.svg?url';
import dePreview from 'src/assets/wheel-text/de-preview.svg?url';
import deWizard from 'src/assets/wheel-text/de-wizard.svg?url';

import enFull from 'src/assets/wheel-text/en-full.svg?url';
import enPreview from 'src/assets/wheel-text/en-preview.svg?url';
import enWizard from 'src/assets/wheel-text/en-wizard.svg?url';

import esFull from 'src/assets/wheel-text/es-full.svg?url';
import esPreview from 'src/assets/wheel-text/es-preview.svg?url';
import esWizard from 'src/assets/wheel-text/es-wizard.svg?url';

import frFull from 'src/assets/wheel-text/fr-full.svg?url';
import frPreview from 'src/assets/wheel-text/fr-preview.svg?url';
import frWizard from 'src/assets/wheel-text/fr-wizard.svg?url';

import itFull from 'src/assets/wheel-text/it-full.svg?url';
import itPreview from 'src/assets/wheel-text/it-preview.svg?url';
import itWizard from 'src/assets/wheel-text/it-wizard.svg?url';

import jaFull from 'src/assets/wheel-text/ja-full.svg?url';
import jaPreview from 'src/assets/wheel-text/ja-preview.svg?url';
import jaWizard from 'src/assets/wheel-text/ja-wizard.svg?url';

import koFull from 'src/assets/wheel-text/ko-full.svg?url';
import koPreview from 'src/assets/wheel-text/ko-preview.svg?url';
import koWizard from 'src/assets/wheel-text/ko-wizard.svg?url';

import nlFull from 'src/assets/wheel-text/nl-full.svg?url';
import nlPreview from 'src/assets/wheel-text/nl-preview.svg?url';
import nlWizard from 'src/assets/wheel-text/nl-wizard.svg?url';

import plFull from 'src/assets/wheel-text/pl-full.svg?url';
import plPreview from 'src/assets/wheel-text/pl-preview.svg?url';
import plWizard from 'src/assets/wheel-text/pl-wizard.svg?url';

import ptFull from 'src/assets/wheel-text/pt-full.svg?url';
import ptPreview from 'src/assets/wheel-text/pt-preview.svg?url';
import ptWizard from 'src/assets/wheel-text/pt-wizard.svg?url';

import ruFull from 'src/assets/wheel-text/ru-full.svg?url';
import ruPreview from 'src/assets/wheel-text/ru-preview.svg?url';
import ruWizard from 'src/assets/wheel-text/ru-wizard.svg?url';

import trFull from 'src/assets/wheel-text/tr-full.svg?url';
import trPreview from 'src/assets/wheel-text/tr-preview.svg?url';
import trWizard from 'src/assets/wheel-text/tr-wizard.svg?url';

import ukFull from 'src/assets/wheel-text/uk-full.svg?url';
import ukPreview from 'src/assets/wheel-text/uk-preview.svg?url';
import ukWizard from 'src/assets/wheel-text/uk-wizard.svg?url';

import zhFull from 'src/assets/wheel-text/zh-full.svg?url';
import zhPreview from 'src/assets/wheel-text/zh-preview.svg?url';
import zhWizard from 'src/assets/wheel-text/zh-wizard.svg?url';

export interface WheelTextFiles {
  full: string,
  preview: string,
  wizard: string,
}

export const filesByLanguage = {
  cs: { full: csFull, preview: csPreview, wizard: csWizard },
  de: { full: deFull, preview: dePreview, wizard: deWizard },
  en: { full: enFull, preview: enPreview, wizard: enWizard },
  es: { full: esFull, preview: esPreview, wizard: esWizard },
  fr: { full: frFull, preview: frPreview, wizard: frWizard },
  it: { full: itFull, preview: itPreview, wizard: itWizard },
  ja: { full: jaFull, preview: jaPreview, wizard: jaWizard },
  ko: { full: koFull, preview: koPreview, wizard: koWizard },
  nl: { full: nlFull, preview: nlPreview, wizard: nlWizard },
  pl: { full: plFull, preview: plPreview, wizard: plWizard },
  pt: { full: ptFull, preview: ptPreview, wizard: ptWizard },
  ru: { full: ruFull, preview: ruPreview, wizard: ruWizard },
  tr: { full: trFull, preview: trPreview, wizard: trWizard },
  uk: { full: ukFull, preview: ukPreview, wizard: ukWizard },
  zh: { full: zhFull, preview: zhPreview, wizard: zhWizard },
} satisfies Record<string, WheelTextFiles>;

export type Language = keyof typeof filesByLanguage;

export const languageByLocale: Record<string, Language> = {
  'cs-CZ': 'cs',
  'de-CH': 'de',
  'de-DE': 'de',
  'es-CL': 'es',
  'es-ES': 'es',
  'es-MX': 'es',
  'fr-BE': 'fr',
  'fr-CA': 'fr',
  'fr-CH': 'fr',
  'fr-FR': 'fr',
  'fr-MA': 'fr',
  'it-IT': 'it',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'nl-BE': 'nl',
  'nl-NL': 'nl',
  'pl-PL': 'pl',
  'pt-BR': 'pt',
  'ru-RU': 'ru',
  'tr-TR': 'tr',
  'uk-UA': 'uk',
  'zh-CN': 'zh',
};
